import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Points a metadata instance's icon at an EXISTING image key via a
// single-slot image pack: imagePacks[uid] = [[imageKey]]. The client already
// resolves this (GetEntityImageKey consults ImagePacks before falling back
// to the raw uid), and the editor's getImageUrl mirrors it. Pure data write —
// no file traffic — so re-skinning shared icons stays trivial, and the
// reference is visible to image-classification scans.
//
// Passing no imageKey (or the uid itself) clears the indirection so a direct
// images[uid] entry (fresh upload) shows again.
export class SetMetadataIconCommand extends CommandBase {
    uid: string;
    imageKey: string | undefined;

    constructor(uid: string, imageKey: string | undefined) {
        super();
        this.uid = uid;
        this.imageKey = imageKey;
    }

    execute(data: RemoteConstantsModel): boolean {
        if (!this.imageKey || this.imageKey === this.uid) {
            if (data.imagePacks && this.uid in data.imagePacks) {
                delete data.imagePacks[this.uid];
                return true;
            }
            return false;
        }

        data.imagePacks ??= {};
        data.imagePacks[this.uid] = [[this.imageKey]];
        return true;
    }
}
